import { type GeofenceDefType, GeofencesDef, GeofenceType } from '@cobliteam/common-types/src/geofenceV3';
import { useTranslation } from '@cobliteam/i18n';

export const useTranslatedGeofences = () => {
  const { t } = useTranslation('geofences');

  const getTranslatedGeofencesDef = (): Record<GeofenceType, GeofenceDefType> => {
    return {
      [GeofenceType.BASE]: {
        ...GeofencesDef[GeofenceType.BASE],
        label: t('geofence_types.base'),
      },
      [GeofenceType.HEADQUARTER]: {
        ...GeofencesDef[GeofenceType.HEADQUARTER],
        label: t('geofence_types.headquarters'),
      },
      [GeofenceType.SUPPLY]: {
        ...GeofencesDef[GeofenceType.SUPPLY],
        label: t('geofence_types.supply'),
      },
      [GeofenceType.MAINTENANCE]: {
        ...GeofencesDef[GeofenceType.MAINTENANCE],
        label: t('geofence_types.maintenance'),
      },
      [GeofenceType.CLIENT]: {
        ...GeofencesDef[GeofenceType.CLIENT],
        label: t('geofence_types.client'),
      },
      [GeofenceType.PATH]: {
        ...GeofencesDef[GeofenceType.PATH],
        label: t('geofence_types.route'),
      },
      [GeofenceType.STATE]: {
        ...GeofencesDef[GeofenceType.STATE],
        label: t('geofence_types.state'),
      },
      [GeofenceType.CITY]: {
        ...GeofencesDef[GeofenceType.CITY],
        label: t('geofence_types.city'),
      },
      [GeofenceType.OTHER]: {
        ...GeofencesDef[GeofenceType.OTHER],
        label: t('geofence_types.other'),
      },
      [GeofenceType.DEFAULT]: {
        ...GeofencesDef[GeofenceType.DEFAULT],
        label: t('geofence_types.location'),
      },
    };
  };

  return {
    getTranslatedGeofencesDef,
  };
};
